import {
  Box,
  Button,
  Flex,
  Heading,
  HStack,
  Image,
  StackDivider,
  Text,
} from '@chakra-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import HappyImage from '../assets/happy_face.svg';
import SadImage from '../assets/sad_face.svg';
import {
  ACTIVE_STAGES,
  BetState,
  doesBetHaveAction,
  OFFER_STAGES,
} from '../store/bets/betsSlice';
import { RootState } from '../store/reducers';
import { BetsTableContext } from './BetsTable';

const ActionElement = ({ actionLabel, onAction, helperLabel }) => (
  <Box textAlign="center">
    <Text
      textDecor="underline"
      color="blue.600"
      onClick={onAction}
      cursor="pointer"
      fontSize="xl"
      fontWeight={500}
    >
      {actionLabel}
    </Text>
    <Text fontSize="xs" fontWeight={500}>
      {helperLabel}
    </Text>
  </Box>
);

interface ActionableBets {
  [bets: string]: string[];
}

const STAGE_MAP = {
  ACTIVE: 0,
  OFFER: 1,
  CLOSED: 2,
};

const UrgentActions = (props) => {
  const _bets = useSelector((state: RootState) => state.bets);
  const [, setBetsTableState] = useContext(BetsTableContext);

  const [actionableBets, setActionableBets] = useState<ActionableBets>();
  const [hasActionables, setHasActionables] = useState(false);

  useEffect(() => {
    const bets = Object.values(_bets);

    const actionableOfferedBets = bets
      .filter(
        (bet) => OFFER_STAGES.includes(bet.stage) && doesBetHaveAction(bet)
      )
      .map((c) => c.contractId);

    const actionableActiveBets = bets
      .filter(
        (bet) => ACTIVE_STAGES.includes(bet.stage) && doesBetHaveAction(bet)
      )
      .map((c) => c.contractId);

    const recentClosedBets = bets
      .filter((bet) => bet.stage === BetState.Closed && !!bet.closeInfo)
      .map((c) => c.contractId);

    setHasActionables(
      actionableActiveBets.length + actionableOfferedBets.length > 0
    );

    setActionableBets({
      ACTIVE: actionableActiveBets,
      OFFER: actionableOfferedBets,
      LOST: recentClosedBets,
    });
  }, [_bets]);

  const setSelectedBets = (stage: string) => {
    if (!actionableBets) return;
    setBetsTableState({
      tabIndex: STAGE_MAP[stage],
      selectedBets: actionableBets[stage],
    });
  };

  if (!actionableBets || !hasActionables) return <></>;
  return (
    <Box bg="white" p={4} borderRadius="4px" {...props}>
      <HStack
        justifyContent="space-around"
        divider={<StackDivider color="gray.400" />}
      >
        {actionableBets.ACTIVE?.length > 0 && (
          <Flex h="100px" w="40%" justifyContent="center" mx="auto">
            <Image src={HappyImage} />
            <Box my="auto">
              <Heading size="md" mb={4}>
                Congratulations! You won {actionableBets.ACTIVE?.length} bet
                {actionableBets.ACTIVE?.length > 1 ? 's' : ''}
              </Heading>
              <Link to="/payout">
                <Button colorScheme="blue" w="full">
                  View / Withdraw Winnings
                </Button>
              </Link>
            </Box>
          </Flex>
        )}
        {actionableBets.LOST?.length > 0 && (
          <Flex h="100px" w="40%" justifyContent="center" mx="auto">
            <Image src={SadImage} />
            <Box my="auto">
              <Heading size="md">
                Looks like you lost {actionableBets.LOST?.length} bet
                {actionableBets.LOST?.length > 1 ? 's' : ''}
              </Heading>
              <Text fontSize="sm">
                You can view these bets under the "Past Bets" tab
              </Text>
            </Box>
          </Flex>
        )}
      </HStack>

      {actionableBets.OFFER?.length > 0 && (
        <Box>
          <Heading color="#e02020" size="md" textAlign="center" mb={4}>
            Action Required
          </Heading>
          <Flex justifyContent="space-around" width="60%" mx="auto">
            {actionableBets.OFFER?.length > 0 && (
              <ActionElement
                helperLabel="Under Active Offers Tab"
                onAction={() => setSelectedBets('OFFER')}
                actionLabel="Confirm Bets"
              />
            )}
          </Flex>
        </Box>
      )}

      {/* <Flex justifyContent="space-around" width="60%" mx="auto">
        {actionableBets.OFFER?.length > 0 && (
          <ActionElement
            helperLabel="Under Active Offers Tab"
            onAction={() => setSelectedBets('OFFER')}
            actionLabel="Confirm Bets"
          />
        )}
        {actionableBets.ACTIVE?.length > 0 && (
          <ActionElement
            helperLabel="Under Active Bets Tab"
            onAction={() => setSelectedBets('ACTIVE')}
            actionLabel="Withdraw Winnings"
          />
        )}
      </Flex> */}
    </Box>
  );
};

export default UrgentActions;
